<template>
  <div>
    <div class="mb-1 d-flex align-baseline">
      <div class="subtitle2 mr-1">{{ $t("ticketDetails.users") }}:</div>
      <div>
        <div data-testid="ticket-preview-users" class="body2">
          {{ ticketDetails.sections.triggeredUser }}
        </div>
      </div>
    </div>

    <users-protection-alert
      v-if="showAddToProtectionBtn"
      class="mb-1"
      :ticket-details="ticketDetails"
      :add-users-not-allowed="addUsersNotAllowed"
      @on-users-add-clicked="addUsers(usersToAdd)"
    />

    <div class="mb-1">
      <span class="subtitle2">{{ $t("ticketDetails.when") }}: </span>
      <span class="body2" data-testid="ticket-preview-when">
        {{ getFormattedDateTime(ticketDetails.endTime, "MMM, DD YYYY, h:mm A") }}
      </span>
    </div>

    <div class="d-flex align-center mb-1">
      <div class="subtitle2">{{ $t("general.service") }}:</div>
      <div class="d-flex align-center">
        <coro-icon class="service-icon" :icon-name="ticketDetails.sections.serviceName"></coro-icon>
        <span
          class="body2"
          :data-testid="`ticket-preview-service-${ticketDetails.sections.serviceName}`"
        >
          {{ $t(`services.${ticketDetails.sections.serviceName}`) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TicketDetails } from "@/_store/tickets/tickets.module";
import CoroIcon from "@/components/CoroIcon.vue";
import { useTicketPreviewGeneralInfo } from "@/composables/useTicketPreviewGeneralInfo";
import UsersProtectionAlert from "@/components/tickets/ticket-preview-details/UsersProtectionAlert.vue";

const props = defineProps<{
  ticketDetails: TicketDetails;
}>();

const { getFormattedDateTime, addUsersNotAllowed, usersToAdd, showAddToProtectionBtn, addUsers } =
  useTicketPreviewGeneralInfo(props.ticketDetails);
</script>

<style lang="scss" scoped>
.service-icon {
  width: 25px;
  height: 25px;
}
</style>
